import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
	components: {
		Button: {
			baseStyle: {
				borderRadius: '12px',
				// Floating/Layered Content - UI 2026
				boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.04)',
				transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
				boxSizing: 'border-box',
				color: 'white', // Todos los botones tienen texto blanco por defecto
				_focus: {
					boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
					color: 'white'
				},
				_active: {
					transform: 'translateY(1px)',
					boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.08)',
					color: 'white'
				},
				_hover: {
					transform: 'translateY(-2px)',
					boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.12), 0 2px 6px 0 rgba(0, 0, 0, 0.06)',
					color: 'white'
				}
			},
			variants: {
				outline: (props: any) => ({
					borderRadius: '16px',
					border: '1px solid',
					borderColor: mode('rgba(148, 163, 184, 0.28)', 'rgba(148, 163, 184, 0.24)')(props),
					bg: mode('rgba(248, 250, 252, 0.88)', 'rgba(255, 255, 255, 0.06)')(props),
					color: mode('gray.800', 'gray.100')(props),
					fontWeight: '800',
					_hover: {
						bg: mode('rgba(241, 245, 249, 0.96)', 'rgba(255, 255, 255, 0.10)')(props),
						borderColor: mode('rgba(99, 102, 241, 0.28)', 'rgba(147, 197, 253, 0.26)')(props),
						color: mode('gray.900', 'white')(props)
					},
					_focus: {
						color: mode('gray.900', 'white')(props)
					},
					_active: {
						bg: mode('rgba(226, 232, 240, 0.96)', 'rgba(255, 255, 255, 0.13)')(props),
						color: mode('gray.900', 'white')(props)
					}
				}),
				brand: (props: any) => ({
					bg: mode('linear-gradient(135deg, #4F46E5 0%, #2563EB 100%)', 'linear-gradient(135deg, #4F46E5 0%, #3B82F6 100%)')(props),
					color: 'white',
					border: '1px solid',
					borderColor: mode('rgba(99, 102, 241, 0.30)', 'rgba(147, 197, 253, 0.22)')(props),
					borderRadius: '18px',
					fontWeight: '850',
					boxShadow: mode('0 16px 34px rgba(37, 99, 235, 0.24)', '0 18px 38px rgba(37, 99, 235, 0.20)')(props),
					_focus: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props)
					},
					_active: {
						bg: mode('linear-gradient(135deg, #3730A3 0%, #1E40AF 100%)', 'linear-gradient(135deg, #3730A3 0%, #1D4ED8 100%)')(props)
					},
					_hover: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props),
						boxShadow: mode('0 20px 44px rgba(37, 99, 235, 0.28)', '0 20px 44px rgba(37, 99, 235, 0.26)')(props)
					}
				}),
				darkBrand: (props: any) => ({
					bg: mode('brand.900', 'brand.400')(props),
					color: 'white',
					_focus: {
						bg: mode('brand.900', 'brand.400')(props)
					},
					_active: {
						bg: mode('brand.900', 'brand.400')(props)
					},
					_hover: {
						bg: mode('brand.800', 'brand.400')(props)
					}
				}),
				lightBrand: (props: any) => ({
					bg: mode('brand.400', 'rgba(66, 42, 251, 0.6)')(props),
					color: 'white',
					_focus: {
						bg: mode('brand.500', 'rgba(66, 42, 251, 0.7)')(props)
					},
					_active: {
						bg: mode('brand.500', 'rgba(66, 42, 251, 0.7)')(props)
					},
					_hover: {
						bg: mode('brand.500', 'rgba(66, 42, 251, 0.7)')(props)
					}
				}),
				light: (props: any) => ({
					bg: mode('gray.500', 'rgba(255, 255, 255, 0.3)')(props),
					color: 'white',
					_focus: {
						bg: mode('gray.600', 'rgba(255, 255, 255, 0.4)')(props)
					},
					_active: {
						bg: mode('gray.600', 'rgba(255, 255, 255, 0.4)')(props)
					},
					_hover: {
						bg: mode('gray.600', 'rgba(255, 255, 255, 0.4)')(props)
					}
				}),
				action: (props: any) => ({
					fontWeight: '850',
					borderRadius: '18px',
					bg: mode('linear-gradient(135deg, #4F46E5 0%, #2563EB 100%)', 'linear-gradient(135deg, #4F46E5 0%, #3B82F6 100%)')(props),
					color: 'white',
					border: '1px solid',
					borderColor: mode('rgba(99, 102, 241, 0.30)', 'rgba(147, 197, 253, 0.22)')(props),
					boxShadow: mode('0 16px 34px rgba(37, 99, 235, 0.24)', '0 18px 38px rgba(37, 99, 235, 0.20)')(props),
					_focus: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props)
					},
					_active: { bg: mode('linear-gradient(135deg, #3730A3 0%, #1E40AF 100%)', 'linear-gradient(135deg, #3730A3 0%, #1D4ED8 100%)')(props) },
					_hover: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props)
					}
				}),
				setup: (props: any) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('transparent', 'rgba(66, 42, 251, 0.2)')(props),
					border: mode('1px solid', '1px solid')(props),
					borderColor: mode('gray.400', 'rgba(255, 255, 255, 0.2)')(props),
					color: 'white', // Texto blanco en todos los modos
					_focus: {
						bg: mode('transparent', 'brand.400')(props),
						color: 'white'
					},
					_active: { 
						bg: mode('transparent', 'brand.400')(props),
						color: 'white'
					},
					_hover: {
						bg: mode('secondaryGray.100', 'brand.400')(props),
						color: 'white'
					}
				}),
				ghost: (props: any) => ({
					bg: 'transparent',
					color: mode('gray.700', 'gray.100')(props),
					_hover: {
						bg: mode('rgba(15, 23, 42, 0.05)', 'rgba(255, 255, 255, 0.08)')(props),
						color: mode('gray.900', 'white')(props)
					},
					_focus: {
						bg: mode('rgba(15, 23, 42, 0.05)', 'rgba(255, 255, 255, 0.08)')(props),
						color: mode('gray.900', 'white')(props)
					},
					_active: {
						bg: mode('rgba(15, 23, 42, 0.08)', 'rgba(255, 255, 255, 0.12)')(props),
						color: mode('gray.900', 'white')(props)
					}
				}),
				solid: (props: any) => ({
					bg: mode('linear-gradient(135deg, #4F46E5 0%, #2563EB 100%)', 'linear-gradient(135deg, #4F46E5 0%, #3B82F6 100%)')(props),
					color: 'white',
					border: '1px solid',
					borderColor: mode('rgba(99, 102, 241, 0.30)', 'rgba(147, 197, 253, 0.22)')(props),
					borderRadius: '18px',
					fontWeight: '850',
					boxShadow: mode('0 16px 34px rgba(37, 99, 235, 0.24)', '0 18px 38px rgba(37, 99, 235, 0.20)')(props),
					_hover: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props),
						color: 'white'
					},
					_focus: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props),
						color: 'white'
					},
					_active: {
						bg: mode('linear-gradient(135deg, #3730A3 0%, #1E40AF 100%)', 'linear-gradient(135deg, #3730A3 0%, #1D4ED8 100%)')(props),
						color: 'white'
					}
				}),
				adminPrimary: (props: any) => ({
					bg: mode('linear-gradient(135deg, #4F46E5 0%, #2563EB 100%)', 'linear-gradient(135deg, #4F46E5 0%, #3B82F6 100%)')(props),
					color: 'white',
					border: '1px solid',
					borderColor: mode('rgba(99, 102, 241, 0.30)', 'rgba(147, 197, 253, 0.22)')(props),
					borderRadius: '18px',
					fontWeight: '850',
					boxShadow: mode('0 16px 34px rgba(37, 99, 235, 0.24)', '0 18px 38px rgba(37, 99, 235, 0.20)')(props),
					_hover: {
						bg: mode('linear-gradient(135deg, #4338CA 0%, #1D4ED8 100%)', 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)')(props),
						boxShadow: mode('0 20px 44px rgba(37, 99, 235, 0.28)', '0 20px 44px rgba(37, 99, 235, 0.26)')(props),
						transform: 'translateY(-1px)'
					},
					_active: {
						bg: mode('linear-gradient(135deg, #3730A3 0%, #1E40AF 100%)', 'linear-gradient(135deg, #3730A3 0%, #1D4ED8 100%)')(props),
						transform: 'translateY(0)'
					}
				}),
				adminSecondary: (props: any) => ({
					bg: mode('rgba(248, 250, 252, 0.88)', 'rgba(255, 255, 255, 0.06)')(props),
					color: mode('gray.800', 'gray.100')(props),
					border: '1px solid',
					borderColor: mode('rgba(148, 163, 184, 0.28)', 'rgba(148, 163, 184, 0.24)')(props),
					borderRadius: '16px',
					fontWeight: '800',
					boxShadow: mode('0 10px 24px rgba(15, 23, 42, 0.08)', '0 14px 30px rgba(2, 6, 23, 0.20)')(props),
					_hover: {
						bg: mode('rgba(241, 245, 249, 0.96)', 'rgba(255, 255, 255, 0.10)')(props),
						borderColor: mode('rgba(99, 102, 241, 0.28)', 'rgba(147, 197, 253, 0.26)')(props),
						color: mode('gray.900', 'white')(props),
						transform: 'translateY(-1px)'
					},
					_active: {
						bg: mode('rgba(226, 232, 240, 0.96)', 'rgba(255, 255, 255, 0.13)')(props),
						transform: 'translateY(0)'
					}
				}),
				adminDanger: (props: any) => ({
					bg: mode('rgba(254, 226, 226, 0.88)', 'rgba(127, 29, 29, 0.22)')(props),
					color: mode('red.700', 'red.100')(props),
					border: '1px solid',
					borderColor: mode('rgba(248, 113, 113, 0.34)', 'rgba(248, 113, 113, 0.28)')(props),
					borderRadius: '16px',
					fontWeight: '800',
					_hover: {
						bg: mode('rgba(254, 202, 202, 0.96)', 'rgba(153, 27, 27, 0.30)')(props),
						color: mode('red.800', 'white')(props)
					}
				})
			}
		}
	}
};
